import { capture } from "@/lib/sentry/capture";
import { logger } from "@/utils/logger";

export function reportDocumentTableFailure(operation: string, error: unknown): void {
  const failure = error instanceof Error ? error : new Error(String(error));
  const eventId = capture(failure, {
    tags: { area: "documents", operation },
    fingerprint: ["document-table", operation],
    context: {},
  });
  void logger.error("data", operation, "Document table operation failed", failure, {
    sentry_event_id: eventId,
  });
}
